import {
    normalizeParts,
    ENTITY_PART_TYPE_TCE,
    SEPARATOR_FORWARD_SLASH,
    trimTrailingSeparators,
} from '_legacy/models/common/EntityPart';
import FortCellEditor from '_legacy/modules/shared/columns/editors/FortCellEditor';
import MultipleSelect from '_legacy/modules/shared/columns/inputs/MultipleSelect';
import PopupWindow from '_legacy/modules/shared/columns/popupWindows/PopupWindow';
import { forwardRef, useRef, useImperativeHandle } from 'react';
import { ICellEditorParams } from '@ag-grid-community/all-modules';
import { createSeparatorTcePart } from './TcePart';
import { tceFormatterInstance } from './formatters/TceFormatter';
import TceInput from './TceInput';

const TceEditor = forwardRef((props: ICellEditorParams, ref) => {
    const selectRef = useRef<any>();
    const focus = () => {
        selectRef?.current?.focus();
    };

    const handleOnTab = () => props.api?.tabToNextCell();
    const handleOnTabBack = () => props.api?.tabToPreviousCell();
    const handleOnEnter = () => props.stopEditing();

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (selectRef?.current?.formattedValue().length > 0) {
                    var parts = normalizeParts(
                        selectRef?.current?.formattedValue().map((part) => {
                            return {
                                tceValue: part.tceValue,
                                separatorValue: part.separatorValue,
                                partType: part.partType,
                            };
                        }),
                        createSeparatorTcePart,
                        getDefaultSeparator()
                    );
                    return trimTrailingSeparators(parts);
                } else {
                    return null;
                }
            },

            isPopup() {
                return true;
            },

            afterGuiAttached() {
                focus();
            },
        };
    });

    const getDefaultSeparator = () => {
        return SEPARATOR_FORWARD_SLASH;
    };

    const getMultiselectStyles = () => {
        return { maxWidth: '800px' };
    };

    return (
        <FortCellEditor blockNavigation={false} {...props}>
            <PopupWindow
                ref={selectRef}
                context={props.context}
                value={props.value}
                data={props.node.data}
                onTab={handleOnTab}
                onTabBack={handleOnTabBack}
                onEnter={handleOnEnter}
                shouldSelectItemOnTab={true}
                inputClass="ag-react-container"
                createSeparatorPart={createSeparatorTcePart}
                entityPartTypesOfValuePart={[ENTITY_PART_TYPE_TCE]}
                partsFormatterInstance={tceFormatterInstance}
                defaultSeparator={getDefaultSeparator()}
                multiselectStyles={getMultiselectStyles()}
                multipleSelect={<MultipleSelect />}
                input={
                    <TceInput
                        initialChar={props.charPress}
                        onEnter={handleOnEnter}
                    />
                }
            ></PopupWindow>
        </FortCellEditor>
    );
});

export default TceEditor;
